<template>
  <div class="realtimeMin" :class="{ realtime: screenSize > 1200 }">
    <div class="chartBox" :class="{ chartBoxMin: screenSize < 1200 }" ref="speed"></div>
    <div class="chartBox" :class="{ chartBoxMin: screenSize < 1200 }" ref="power"></div>
    <div
      class="chartBox"
      :class="{ chartBoxMin: screenSize < 1200 }"
      ref="pressure"
    ></div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { onMounted, onUnmounted } from "vue";
import * as echarts from "echarts";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
const screenSize = ref();
const width = window.innerWidth;
screenSize.value = width;
const props = defineProps({
  devicein: { type: Object, required: true },
});

const realData = ref({
  speed: props.devicein.speed,
  power: props.devicein.power,
  pressure: props.devicein.pressure,
});

let speed = ref(null);
let power = ref(null);
let pressure = ref(null);

let myEcharts = echarts;

onMounted(() => {
  if (realData.value) {
    initSpeedChart();
    initPowerChart();
    initPressureChart();
  }
});

onUnmounted(() => {
  myEcharts.dispose;
});

function initSpeedChart() {
  let chart = myEcharts.init(speed.value, null, {
    renderer: "svg",
  });
  let option;
  let mainColor = "#fac858";

  option = {
    series: [
      {
        name: "Indicator",
        type: "gauge",
        data: [
          {
            value: realData.value.speed,
            name: `${t("index.speed")}(m/min)`,
            itemStyle: { color: mainColor },
            title: {
              show: true,
              offsetCenter: ["0", "100%"],
            },
          },
        ],
        detail: {
          show: true,
        },
        max: 1000,
        splitNumber: 10,
        progress: {
          show: true,
          itemStyle: {
            color: mainColor,
          },
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: [[1, "rgba(250, 200, 88, 0.2)"]],
          },
        },
      },
    ],
  };
  option && chart.setOption(option);
  window.onresize = function () {
    chart.resize();
  };
}

function initPowerChart() {
  let chart = myEcharts.init(power.value, null, {
    renderer: "svg",
  });
  let option;
  let mainColor = "#0064c8";

  option = {
    series: [
      {
        name: "Indicator",
        type: "gauge",
        data: [
          {
            value: realData.value.power,
            name: `${t("index.power")}(kW)`,
            itemStyle: { color: mainColor },
            title: {
              show: true,
              offsetCenter: ["0", "100%"],
            },
          },
        ],
        detail: {
          show: true,
        },
        max: 60,
        splitNumber: 10,
        progress: {
          show: true,
          itemStyle: {
            color: mainColor,
          },
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: [[1, "rgba(84, 112, 198, 0.2)"]],
          },
        },
      },
    ],
  };
  option && chart.setOption(option);
  window.onresize = function () {
    chart.resize();
  };
}

function initPressureChart() {
  let chart = myEcharts.init(pressure.value, null, {
    renderer: "svg",
  });
  let option;
  let mainColor = "#50aa50";

  option = {
    series: [
      {
        name: "Indicator",
        type: "gauge",
        data: [
          {
            value: realData.value.pressure,
            name: `${t("index.pressure")}(bar)`,
            itemStyle: { color: mainColor },
            title: {
              show: true,
              offsetCenter: ["0", "100%"],
            },
          },
        ],
        detail: {
          show: true,
        },
        max: 1000,
        splitNumber: 10,
        progress: {
          show: true,
          itemStyle: {
            color: mainColor,
          },
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: [[1, "rgba(80, 170, 80, 0.2)"]],
          },
        },
      },
    ],
  };
  option && chart.setOption(option);
  window.onresize = function () {
    chart.resize();
  };
}
</script>

<style scoped>
.realtime {
  width: 100%;
  height: 310px;
  display: flex;
  justify-content: space-between;
}
.realtimeMin {
  width: 100%;
  justify-content: space-between;
}
.chartBox {
  width: 33%;
  height: 100%;
}
.chartBoxMin {
  width: 100% !important;
  height: 310px !important;
}
</style>
